export default {
  SET_ADVERTISE: (state, advertise) => {
    state.advertise = {...advertise}
  },

  SET_CLIENT_NAME: (state, clientName) => {
    state.clientName = new String(clientName)
  },

  SET_CLIENT_LOGO: (state, clientLogo) => {
    state.clientLogo = new String(clientLogo)
  },

  SET_AUTHENTICATION: (state, authenticated) => {
    state.isAuthenticated = authenticated
  },

  SET_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  },
}
